export enum RoleAccessAction {
  CREATE = 'create',
  UPDATE = 'update',
  READ = 'read',
  DELETE = 'delete',
  BILLING_READ = 'billing_read',
  BILLING_UPDATE = 'billing_update',
  READ_ACCESS = 'access_read',
  UPDATE_ACCESS = 'access_update',
}
